<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H7Edx8/tc-custom/9781610580854.jpg?1736886756299" alt="This image is the cover for the book 500 Low Sodium Recipes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">500 Low Sodium Recipes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Flavorful and fun low sodium recipes for the new you—new low sodium versions of your classic favorites.</b></p><p>Shake free of your anxiety about your new low sodium diet and discover how easy it is to make all the delicious dishes and snacks you love, using tasty, easy-to-find low sodium foods and ingredients.</p><p><i>500 Low Sodium Recipes</i> offers quick recipes for making low sodium versions of the ingredients you thought you had to give up: beef, chicken, and vegetable stocks, gravies, dressings, breadings, and stuffings.</p><p>Packed with 500 recipes—everything from satisfying slow-cooker fare to marvelous munchies—<i>500 Low Sodium Recipes</i> will be your key to maintaining a diverse and exciting low sodium diet. Each recipe features a nutritional breakdown, making it easier than every to track your daily sodium intake.</p><p>Bring the foods you and your family love back to the table, including, Chicken Pot Pie, Honey-Glazed Spareribs, Ginger-Apple Braised Pork Chops, Shrimp Pasta Primavera, and Balsamic and Maple Salmon.</p><p>Don’t give up on your favorite soups, sauces, and chilis. Dig your spoon into a bowl of Minestrone, French Onion Soup, or Chicken Corn Chowder. Slather on one of the seven barbeque sauces you’ll find inside or pick from one of the eight—yes, eight—different recipes for chili!</p><p>Why pass on all those yummy cookies, cobblers, and cakes? Try Blackberry Cobbler, Chocolate Chip Cookies, or Devil’s Food Cake.</p><p>Who needs take-out food when you can bring the world to your kitchen in low sodium style? You’ll find chapters devoted to dishes that will quench your international cravings—Italian, Mexican, Asian, Latin American, Caribbean, and more.</p><p>Your family will love all these low sodium versions of their favorites, and more important you’ll stay on your path to a healthier new you.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dick Logue
      </h2>
      
      <p class="authorDescription body article">Dick Logue is the author of several diet-friendly cookbooks and has been following a heart-healthy lifestyle for decades now. After being diagnosed with congestive heart failure more than 20 years ago, Dick threw himself into the process of creating healthy versions of his favorite recipes and writing about it on his website. A cook since the age of 12, he grows his own vegetables, bakes his own bread, and cans a variety of foods. He is the author of 500 Low Sodium Recipes, 500 Low-Cholesterol Recipes, 500 High Fiber Recipes, 500 Low Glycemic Index Recipes, 500 Heart-Healthy Slow Cooker Recipes, 500 400-Calorie Recipes, and 500 15-Minute Low Sodium Recipes, among others. He lives in La Plata, Maryland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fair Winds Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ebcff0e